define('controllers/consoleApi/myApi.ctrl',['app'], function (app) {
    app.controller('myApiCtrl', ['$scope', '$state','$rootScope','$stateParams','projectManageService','biAnalyticService',
        function ($scope, $state,$rootScope,$stateParams,projectManageService,biAnalyticService) {
            var projectKey=$stateParams.projectKey;
            var Model = $scope.Model = {};
            $scope.createProject= createProject;
            $scope.applyNewApi = applyNewApi;
            $scope.clickApi=clickApi;
            $scope.showMyScope = showMyScope;
            //$rootScope.checkState($state).then(function () {
                init();
            //})
            //创建project
            function createProject() {
                projectManageService.createProject().then(function () {
                    init();
                });
            }
            
            function applyNewApi() {
                $state.go('apiList', {projectKey : Model.myProject.projectKey},  {reload: true});
            }

            function clickApi(apiInfo) {
                $state.go('myApiDetail', {projectKey:Model.myProject.projectKey,apiID:apiInfo.apiID});
            }

            function init() {
                //处理页面  分流 优化接口调用
                if(projectManageService.getProjectKey() !='0' || (projectKey && projectKey != '0') ){
                    Model.isShowPro = true;
                    Model.isHavePro = true;
                    if(projectManageService.getProjectKey() !='0' && !(projectKey && projectKey != '0')){
                        $state.go('myApi',{projectKey:projectManageService.getProjectKey()}, {reload: true});
                    }else{
                        biAnalyticService.trackPageView("APIConsole - 我的API页面", 'DPRM5059');
                        projectManageService.getProjectInfo({projectKey:projectKey}).then(function (data) {
                            if(data && data.projectInfo){
                                Model.myProject = data.projectInfo;
                                projectManageService.setProjectKey(Model.myProject.projectKey);
                                getApiList();
                            }
                        });
                    }
                }else{
                    projectManageService.getProjectList().then(function (data) {
                    Model.isShowPro = true;
                    if(data && data.projectInfoList.length>0){
                        Model.isHavePro = true;
                        Model.projectInfoList = data.projectInfoList;
                        if(projectKey == '0' ||  !projectKey){
                            Model.myProject = Model.projectInfoList[0];
                            projectManageService.setProjectKey(Model.myProject.projectKey);
                            $state.go('myApi',{projectKey:Model.myProject.projectKey}, {reload: true});
                            getApiList();
                        }
                    }else{
                        $state.go('myProject', {reload: true});
                    }
                    }).catch(function () {
                        $state.go('myProject', {reload: true});
                    });
                }
            }

            function getApiList() {
                projectManageService.getProjectAPI(Model.myProject.projectID).then(function (resp) {
                    Model.isShowApi =true;
                    if(resp &&resp.apiInfoList &&  resp.apiInfoList.length>0){
                        Model.isHaveApi = true;
                        Model.apiInfoList = resp.apiInfoList;
                    }else{
                        Model.isHaveApi = false;
                    }
                });
            }
            function showMyScope() {
                $state.go('myApiScope',{
                    projectKey: Model.myProject.projectKey,
                    projectID: Model.myProject.projectID
                }, {reload: true})
            }
        }
    ]);
});

